unit DonorForm;
interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseForm,
  Data.DB,
  WEBLib.DB,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.DBCtrls,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  WEBLib.WebCtrls,
  WEBLib.Toast,
  Vcl.Imaging.GIFImg,
  WEBLib.DropDown,
  WEBLib.Country,
  XData.Web.Client, XData.Web.JsonDataset, XData.Web.Dataset,
  Essentials.Web.Attributes.Form;

type
  TExistingDonorNames = record
    OrganisationName: string;
    FirstNameLastName: string;
  end;

  TDonorEditForm = class(TBaseEditForm)
    edFirstName: TDBEdit;
    edLastName: TDBEdit;
    edAdd1: TDBEdit;
    edAdd2: TDBEdit;
    edAdd3: TDBEdit;
    edCity: TDBEdit;
    edEmail: TDBEdit;
    edMobile: TDBEdit;
    edTelephone: TDBEdit;
    DonorIdLabel: TDBLabel;
    ClaimStatus: TDBLookupComboBox;
    Comments: TDBEdit;
    ContactByPhone: TDBCheckBox;
    ContactByEmail: TDBCheckBox;
    ContactByText: TDBCheckBox;
    ContactByPost: TDBCheckBox;
    ExternalIdLabel: TDBLabel;
    TitleEdit: TDBEdit;
    ExternalIdEdit: TDBEdit;
    edCounty: TDBEdit;
    CountryList: TCountryComboBox;
    DefaultsButton: TButton;
    DeclarationsButton: TButton;
    DonorCommentMemo: TDBMemo;
    OrganisationName: TDBEdit;
    DonorKind: TDBLookupComboBox;
    DateOfDeath: TDBDateTimePicker;
    edPostCode: TEdit;
    DonorDataset: TXDataWebDataSet;
    DonorDatasetId: TIntegerField;
    DonorDatasetDateAdded: TDateTimeField;
    DonorDatasetAddedBy: TIntegerField;
    DonorDatasetLastUpdatedBy: TIntegerField;
    DonorDatasetLastUpdated: TDateTimeField;
    DonorDatasetTitle: TStringField;
    DonorDatasetFirstName: TStringField;
    DonorDatasetMiddleName: TStringField;
    DonorDatasetLastName: TStringField;
    DonorDatasetSuffix: TStringField;
    DonorDatasetAdd1: TStringField;
    DonorDatasetAdd2: TStringField;
    DonorDatasetAdd3: TStringField;
    DonorDatasetCity: TStringField;
    DonorDatasetPostCode: TStringField;
    DonorDatasetEmail: TStringField;
    DonorDatasetMobile: TStringField;
    DonorDatasetTelephone: TStringField;
    DonorDatasetMatchHash: TStringField;
    DonorDatasetVersion: TIntegerField;
    DonorDatasetContactByPhone: TBooleanField;
    DonorDatasetContactByPost: TBooleanField;
    DonorDatasetContactByText: TBooleanField;
    DonorDatasetContactByEmail: TBooleanField;
    DonorDatasetDOB: TDateField;
    DonorDatasetHearingStatus: TStringField;
    DonorDatasetEmailStatus: TStringField;
    DonorDatasetLatitude: TFloatField;
    DonorDatasetLongitude: TFloatField;
    DonorDatasetExternalId: TStringField;
    DonorDatasetCountryCode: TStringField;
    DonorDatasetVisualStatus: TStringField;
    DonorDatasetMobilityStatus: TStringField;
    DonorDatasetSourceType: TStringField;
    DonorDatasetClaimStatus: TStringField;
    DonorDatasetCharityTenant: TStringField;
    DonorDatasetComments: TStringField;
    DonorDatasetImportId: TIntegerField;
    DonorDatasetCounty: TStringField;
    DonorDatasetLocationType: TStringField;
    DonorDatasetOrganisationName: TStringField;
    DonorDatasetDonorKind: TStringField;
    DonorDatasetDateOfDeath: TDateTimeField;

    procedure ClaimStatusChange(Sender: TObject);
    procedure ClaimStatusExit(Sender: TObject);
    procedure DateOfDeathExit(Sender: TObject);
    procedure CountryListChange(Sender: TObject);
    procedure CountryListExit(Sender: TObject);
    procedure DataSourceDataChange(Sender: TObject; Field: TField);
    procedure DataSourceStateChange(Sender: TObject);
    procedure edAdd1Exit(Sender: TObject);
    procedure edFirstNameExit(Sender: TObject);
    procedure edLastNameExit(Sender: TObject);
    procedure edPostCodeXXXExit(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure EditChange(Sender: TObject);
    procedure DefaultsButtonClick(Sender: TObject);
    procedure DeclarationsButtonClick(Sender: TObject);
    procedure OrganisationNameChange(Sender: TObject);
    procedure OrganisationNameExit(Sender: TObject);
    procedure DonorKindChange(Sender: TObject);
    [async]
    procedure SaveButtonClick(Sender: TObject); async;
    procedure CancelButtonClick(Sender: TObject);
    procedure edPostCodeChange(Sender: TObject);
    procedure edPostCodeExit(Sender: TObject);
    procedure DonorDatasetAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
  private
    { Private declarations }
    FClaimStatusValid: boolean;
    FAttributesForm: TEssentialsAttributesForm;
    FExistingDonorNames: TExistingDonorNames;
    FLockedViewMode: Boolean;
    FEnterLockedViewAfterSetDataset: Boolean;
    FEnterEditAfterSetDataset: Boolean;
    FRefreshingDonorData: Boolean;
    FDonorSaveInProgress: Boolean;
    FListRefreshNeeded: Boolean;
    FSuppressApplyUpdatesEvent: Boolean;
    FLastSavedDonorId: Integer;
    FAddingNewDonor: Boolean;
    function EffectiveDonorId: Integer;
    function InsertedDonorIdFromResolve(const AInfo: TResolveResults): Integer;
    function ShouldEnterLockedViewAfterSave: Boolean;
    procedure ExternalIdLabelClick(Sender: TObject);
    procedure UpdateDonorNames;
    procedure SetFormEditable(const AEditable: Boolean);
    procedure SetPrimaryActionButton(const ACaption: string);
    procedure UpdatePrimaryActionEnabled(const ACanSaveInEditMode: Boolean);
    procedure EnterLockedViewMode;
    procedure ApplyEditSessionUI;
    procedure ApplyNewDonorSessionUI;
    procedure UpdateCancelButtonCaption;
    [async]
    procedure EnterEditMode; async;
    [async]
    procedure EnterLockedViewModeAfterSave; async;
    function CanUseEditToggle: Boolean;
    procedure FinalizeLockedViewButtons;
    function DonorSaveActive: Boolean;
    function DonorDatasetReady: Boolean;
    procedure BeginDonorSaveInProgress;
    procedure EndDonorSaveInProgress;

    [Async]
    procedure ExternalIdClick; async;
    procedure AfterSetDataset; override;
    procedure ValidatePostCode;
    function AnyContactAllowed: Boolean;
    procedure CheckValidation;
    procedure SetPostCodeValidation(bValid: boolean);

    [Async]
    procedure ShowDefaults; async;
    [Async]
    procedure ShowDeclarations; async;
    procedure InitAttributesForm;
    procedure ResolveDonorType;
    procedure CheckClaimStatus;
    procedure ApplyDonorData(const AJson: JSValue; const AEnterEditMode: Boolean;
      const AEnterLockedView: Boolean);
    [Async]
    procedure ReloadDonorFromServer; async;

  const zOrganisation = 'Organisation';
        zIndividual = 'Individual';
        zCompany = 'Company';
  protected
    [async]
    procedure TrySaveDonor; async;
    function DisplayName: string;
    function SaveTitle: string; override;
    function SaveDescription: string; override;
    procedure SetSaveInProgressUI(const AInProgress: Boolean); override;
    procedure AfterApplyUpdates(Sender: TDataset; Info: TResolveResults); override;
    procedure RecordChanged; override;
    function CloseOnSave: boolean; override;
    function GetRequiredEditLevel: string; override;
    procedure BeforePostRecord; override;
    procedure SetCountryCode; virtual;
    procedure CheckClaimStatusIsOther;
    procedure UpdateDateOfDeathVisibility;
    procedure ClearDateOfDeathIfNotDeceased;
    function CurrentDonorClaimStatus: string;
    function DonorClaimStatusIsDeceased: Boolean;
    procedure SyncDateOfDeathToDataset;
    procedure SetCountryToCountryCode(ACountryCode: string);
  public
    { Public declarations }
    procedure SetLookUpValues(const AName: string; Value: TLookupValues); override;
    [async]
    procedure LoadDonor(const ADonorId: Integer); async;
    procedure BeginNewDonor;
    procedure AfterEditFormLoaded;
    function SavedDonorId: Integer;
    property ListRefreshNeeded: Boolean read FListRefreshNeeded;
    //property PostCodeValid: boolean read FPostCodeValid write SetPostCodeValidation;
  protected procedure LoadDFMValues; override; end;

implementation

uses
  DonorList,
  SMX.Shared,
  XData.Dataset.Utils,
  Auth.Service,
  SMX.CRM.Utils,
  MainDataModule,
  SMX.Web.Document.Utils,
  DonationDefaults,
  DonorDeclaration,
  GA.Web.Utils,
  GA.Rules,
  smx.webcore.types,
  ErrorForm,
  Essentials.RequiredFields.UtilityUnit;

{$R *.dfm}

procedure TDonorEditForm.ApplyDonorData(const AJson: JSValue; const AEnterEditMode: Boolean;
  const AEnterLockedView: Boolean);
begin
  FEnterLockedViewAfterSetDataset := AEnterLockedView;
  FEnterEditAfterSetDataset := AEnterEditMode;
  FLoading := True;
  try
    DonorDataset.Close;
    DonorDataset.SetJsonData(AJson);
    DonorDataset.Open;

    if AEnterEditMode then
      DonorDataset.Edit;
  finally
    FLoading := False;
  end;

  if Assigned(FAttributesForm) and DonorDatasetReady and (SavedDonorId > 0) then
    FAttributesForm.EntityId := SavedDonorId;

  AfterSetDataset;
end;

procedure TDonorEditForm.BeginNewDonor;
begin
  FListRefreshNeeded := False;
  FLastSavedDonorId := 0;
  FAddingNewDonor := True;
  FEnterLockedViewAfterSetDataset := False;
  FEnterEditAfterSetDataset := False;
  FLockedViewMode := False;
  FLoading := True;
  try
    DonorDataset.Close;
    DonorDataset.SetJsonData('{}');
    DonorDataset.Open;
    DonorDataset.Insert;
  finally
    FLoading := False;
  end;
  AfterSetDataset;
end;

procedure TDonorEditForm.AfterEditFormLoaded;
begin
  TDonationUIUtils.AddDonorKindLookupsToCombo(DonorKind.LookupValues);
  CheckClaimStatusIsOther;
  UpdateDateOfDeathVisibility;
  CheckValidation;

  if not CanUseEditToggle then
    edFirstName.SetFocus;
end;

[async]
procedure TDonorEditForm.LoadDonor(const ADonorId: Integer); async;
var
  lResponse: TXDataClientResponse;
begin
  if ADonorId <= 0 then
    raise Exception.Create('Invalid donor id.');

  FListRefreshNeeded := False;
  FLastSavedDonorId := 0;
  FAddingNewDonor := False;
  lResponse := Await(TXDataClientResponse, WebClient.GetAsync(DonorDataset.EntitySetName, ADonorId));
  if lResponse.Result = nil then
    raise Exception.Create('The selected record could not be found. Please refresh the list and try again.');

  ApplyDonorData(lResponse.Result, False, True);
end;

function TDonorEditForm.SavedDonorId: Integer;
begin
  Result := 0;
  if Assigned(DonorDataset) and DonorDataset.Active and Assigned(DonorDataset.FindField('Id')) then
    Result := DonorDataset.FieldByName('Id').AsInteger;
end;

function TDonorEditForm.EffectiveDonorId: Integer;
begin
  Result := SavedDonorId;
  if Result <= 0 then
    Result := FLastSavedDonorId;
end;

function TDonorEditForm.InsertedDonorIdFromResolve(const AInfo: TResolveResults): Integer;
var
  I: Integer;
  lValue: JSValue;
begin
  Result := 0;
  for I := 0 to Length(AInfo.Records) - 1 do
  begin
    if (AInfo.Records[I].Error <> '') or (AInfo.Records[I].Status <> TUpdateStatus.usInserted) then
      Continue;

    lValue := TJSObject(AInfo.Records[I].Data)['Id'];
    if lValue <> nil then
      Result := Integer(lValue);
    Exit;
  end;
end;

function TDonorEditForm.ShouldEnterLockedViewAfterSave: Boolean;
begin
  Result := (RecordViewOption in [voEdit, voCreateAndEdit]) and (EffectiveDonorId > 0);
end;

[async]
procedure TDonorEditForm.ReloadDonorFromServer; async;
var
  lId: Integer;
  lResponse: TXDataClientResponse;
begin
  lId := EffectiveDonorId;
  if lId <= 0 then
    Exit;

  lResponse := Await(TXDataClientResponse, WebClient.GetAsync(DonorDataset.EntitySetName, lId));
  if lResponse.Result = nil then
    raise Exception.Create('Could not refresh donor from server. Please close and reopen the donor.');

  FRefreshingDonorData := True;
  try
    ApplyDonorData(lResponse.Result, False, False);
  finally
    FRefreshingDonorData := False;
  end;
end;

procedure TDonorEditForm.AfterApplyUpdates(Sender: TDataset; Info: TResolveResults);
var
  I: Integer;
  lList: TDonorListForm;
begin
  inherited;

  for I := 0 to Length(Info.Records) - 1 do
  begin
    if Info.Records[I].Error <> '' then
      Exit;

    if Info.Records[I].Status = TUpdateStatus.usInserted then
    begin
      if DonorDatasetReady then
        FLastSavedDonorId := TXDataDSUtils.UpdateId(DonorDataset, Info, 'Id', I)
      else
        FLastSavedDonorId := InsertedDonorIdFromResolve(Info);

      if FLastSavedDonorId <= 0 then
        Continue;

      if Assigned(FAttributesForm) then
        FAttributesForm.EntityId := FLastSavedDonorId;

      if Owner is TDonorListForm then
      begin
        lList := TDonorListForm(Owner);
        if DonorDatasetReady then
          lList.NotifyNewDonorAdded(
            DonorDataset.FieldByName('FirstName').AsString,
            DonorDataset.FieldByName('LastName').AsString,
            DonorDataset.FieldByName('PostCode').AsString)
        else
          lList.NotifyNewDonorAdded(
            Trim(edFirstName.Text),
            Trim(edLastName.Text),
            Trim(edPostCode.Text));
      end;
    end;
  end;
end;

procedure TDonorEditForm.DonorDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
begin
  if FSuppressApplyUpdatesEvent then
    Exit;
  AfterApplyUpdates(Sender, Info);
end;

procedure TDonorEditForm.AfterSetDataset;
var
  lCountryCode: string;
  lClaimStatus: string;
begin
  inherited;

  if FRefreshingDonorData then
  begin
    UpdateDonorNames;
    if Assigned(DataSource.DataSet) and DataSource.DataSet.Active and
      Assigned(DataSource.DataSet.FindField('Id')) then
    begin
      DefaultsButton.Enabled := DataSource.DataSet.FieldByName('Id').AsString <> '';
      DeclarationsButton.Enabled := DefaultsButton.Enabled;
    end;
    Exit;
  end;

  DefaultsButton.Enabled := Dataset.FieldByName('Id').AsString <> '';
  DeclarationsButton.Enabled := DefaultsButton.Enabled;

  UpdateDonorNames;

  if AuthService.IsAdministrator then
  begin
    if Dataset.FieldByName('ExternalId').AsString <> '' then
    begin
      ExternalIdLabel.OnClick := ExternalIdLabelClick;
      ExternalIdLabel.Cursor := crHandPoint;
    end;
  end;

  if Dataset.FieldByName('CountryCode').AsString <> '' then
  begin
    lCountryCode := Dataset.FieldByName('CountryCode').AsString;
    SetCountryToCountryCode(lCountryCode);
  end
  else
  begin
    if DataSource.DataSet.State in [dsInsert] then
    begin
      SetCountryToCountryCode('GB');
    end;
  end;

  if Dataset.FieldByName('PostCode').AsString <> '' then
  begin
    edPostCode.Text := Dataset.FieldByName('PostCode').AsString;
  end;

  if Dataset.FieldByName('ClaimStatus').AsString <> '' then
  begin
    lClaimStatus := Dataset.FieldByName('ClaimStatus').AsString;
    ClaimStatus.Value := lClaimStatus;
  end;

  if not (DataSource.DataSet.State in [dsInsert]) then
  begin
    ValidatePostCode;
    CheckValidation;

    FClaimStatusValid := True;
  end
  else
  begin
    if DataSource.DataSet.State = dsInsert then
    begin
      if Dataset.FieldByName('DonorKind').AsString = '' then
      begin
        Dataset.FieldByName('DonorKind').AsString := zIndividual;
        DonorKind.Value := zIndividual;
      end;

      ClaimStatus.ItemIndex := MainData.OrganisationConfiguration.DonorClaimStatusItemIndex;
      lClaimStatus := 'NoActiveGiftAid';///ClaimStatus.Items[ClaimStatus.ItemIndex];
      Dataset.FieldByName('ClaimStatus').AsString := lClaimStatus;
      ClaimStatus.ItemIndex := MainData.OrganisationConfiguration.DonorClaimStatusItemIndex;

      FClaimStatusValid := True;

      if Trim(DisplayName) = '' then
        FormCaption.Caption := 'New Donor';
    end;
  end;
  UpdateDateOfDeathVisibility;
  CheckClaimStatusIsOther;
  CheckValidation;

  if FEnterLockedViewAfterSetDataset and CanUseEditToggle then
  begin
    FEnterLockedViewAfterSetDataset := False;
    EnterLockedViewMode;
  end
  else if FEnterEditAfterSetDataset and CanUseEditToggle then
  begin
    FEnterEditAfterSetDataset := False;
    ApplyEditSessionUI;
  end
  else if FAddingNewDonor then
    ApplyNewDonorSessionUI;
end;

function TDonorEditForm.AnyContactAllowed: Boolean;
begin
  result := ContactByEmail.Checked or ContactByPhone.Checked or ContactByPost.Checked or ContactByText.Checked;
end;

procedure TDonorEditForm.BeforePostRecord;
var
  lCountryCode: string;

begin
  inherited;
  lCountryCode := TCountryUtils.GetCountryCodeFromCountryHelper(CountryList.Text);

  Dataset.FieldByName('ContactByPhone').AsBoolean := ContactByPhone.Checked;
  Dataset.FieldByName('ContactByPost').AsBoolean := ContactByPost.Checked;
  Dataset.FieldByName('ContactByText').AsBoolean := ContactByText.Checked;
  Dataset.FieldByName('ContactByEmail').AsBoolean := ContactByEmail.Checked;
  Dataset.FieldByName('CountryCode').AsString := lCountryCode;
  SyncDateOfDeathToDataset;
end;

function TDonorEditForm.CurrentDonorClaimStatus: string;
begin
  if Trim(ClaimStatus.Value) <> '' then
    Result := Trim(ClaimStatus.Value)
  else if Assigned(DataSource.DataSet) and Assigned(DataSource.DataSet.FindField('ClaimStatus')) then
    Result := Trim(DataSource.DataSet.FieldByName('ClaimStatus').AsString)
  else
    Result := '';
end;

function TDonorEditForm.DonorClaimStatusIsDeceased: Boolean;
begin
  Result := SameText(CurrentDonorClaimStatus, 'Deceased');
end;

procedure TDonorEditForm.SyncDateOfDeathToDataset;
var
  lDateOfDeathField: TField;
begin
  if not Assigned(Dataset.FindField('DateOfDeath')) then
    Exit;
  if not (DataSource.DataSet.State in dsEditModes) then
    Exit;

  lDateOfDeathField := Dataset.FieldByName('DateOfDeath');
  if DonorClaimStatusIsDeceased then
  begin
    if DateOfDeath.Date > 0 then
      lDateOfDeathField.AsDateTime := DateOfDeath.Date
    else
      lDateOfDeathField.Clear;
  end
  else
    lDateOfDeathField.Clear;
end;

procedure TDonorEditForm.ClearDateOfDeathIfNotDeceased;
begin
  if FRefreshingDonorData then
    Exit;
  if DonorClaimStatusIsDeceased then
    Exit;

  if Assigned(Dataset.FindField('DateOfDeath')) and (DataSource.DataSet.State in dsEditModes) then
    Dataset.FieldByName('DateOfDeath').Clear;
  DateOfDeath.Date := 0;
end;

procedure TDonorEditForm.CheckClaimStatusIsOther;
begin
  Comments.Visible := (ClaimStatus.Value = 'Other');
end;

procedure TDonorEditForm.UpdateDateOfDeathVisibility;
begin
  DateOfDeath.Visible := DonorClaimStatusIsDeceased;
  TDocUtils.ShowHideLabel('donor.dateofdeath.label', DateOfDeath.Visible);
end;

procedure TDonorEditForm.ClaimStatusChange(Sender: TObject);
begin
  CheckClaimStatusIsOther;
  ClearDateOfDeathIfNotDeceased;
  FormCaption.Caption := DisplayName;
  UpdateDateOfDeathVisibility;
  CheckValidation;
end;

procedure TDonorEditForm.CountryListChange(Sender: TObject);
begin
  inherited;
  SetCountryCode;
end;

procedure TDonorEditForm.CountryListExit(Sender: TObject);
begin
  inherited;
  SetCountryCode;
end;

procedure TDonorEditForm.DataSourceDataChange(Sender: TObject; Field: TField);
begin
  inherited;
  if (Field = nil) and (not DonorSaveActive) and (not FRefreshingDonorData) and DonorDatasetReady then
    FormCaption.Caption := DisplayName;
end;

function TDonorEditForm.DisplayName: string;
var
  isAnOrganisation: Boolean;
begin
  if not DonorDatasetReady then
  begin
    if FExistingDonorNames.OrganisationName <> '' then
      Result := FExistingDonorNames.OrganisationName
    else
      Result := FExistingDonorNames.FirstNameLastName;
    Exit;
  end;

  isAnOrganisation := (Datasource.Dataset.FieldByName('ClaimStatus').AsString = zOrganisation) or
    (Datasource.Dataset.FieldByName('DonorKind').AsString <> zIndividual);

  if isAnOrganisation then
    Result := FExistingDonorNames.OrganisationName
  else
    Result := FExistingDonorNames.FirstNameLastName;
end;


procedure TDonorEditForm.DonorKindChange(Sender: TObject);
begin
  FormCaption.Caption := DisplayName;
  CheckValidation;
end;

procedure TDonorEditForm.edPostCodeChange(Sender: TObject);
begin
  inherited;
  ValidatePostCode;
end;

procedure TDonorEditForm.edPostCodeExit(Sender: TObject);
begin
  inherited;
  if DataSource.DataSet.State in dsEditModes then
    Datasource.Dataset.FieldByName('PostCode').AsString := edPostCode.Text;
end;

procedure TDonorEditForm.edPostCodeXXXExit(Sender: TObject);
begin
  ValidatePostCode;
end;

procedure TDonorEditForm.ExternalIdClick;
begin

end;

procedure TDonorEditForm.ExternalIdLabelClick(Sender: TObject);
begin
  ExternalIdClick;
end;

function TDonorEditForm.GetRequiredEditLevel: string;
begin
  result := SCOPE_ANY_ADMIN;
end;

procedure TDonorEditForm.SaveButtonClick(Sender: TObject);
begin
  if DonorSaveActive then
    Exit;

  if FLockedViewMode and CanUseEditToggle then
  begin
    await(EnterEditMode);
    Exit;
  end;

  await(TrySaveDonor);
end;

[async]
procedure TDonorEditForm.TrySaveDonor; async;
var
  lXData: TXDataWebDataset;
  lInfo: TResolveResults;
  lMessage: string;
  lSaveSucceeded: Boolean;
begin
  if not TRequiredFieldsUtils.ValidateAndShowMessage(Self) then
    Exit;

  if not CanSaveThis then
  begin
    if IsErrorList then
      TErrorPage.Display('You can''t save this yet', TDocUtils.stringsToUL(ErrorList, 'list-group',
        'list-group-item'), True, True)
    else
      ShowMessage('Some details need completing before you can save this');
    Exit;
  end;

  lSaveSucceeded := False;
  BeginDonorSaveInProgress;
  try
    try
      BeforePostRecord;
      DataSource.Dataset.Post;

      lXData := TXDataWebDataset(DataSource.Dataset);
      if TXDataDSUtils.IsModified(lXData) then
      begin
        FSuppressApplyUpdatesEvent := True;
        try
          lInfo := Await(TResolveResults, lXData.ApplyUpdatesAsync);
          AfterApplyUpdates(DataSource.Dataset, lInfo);

          if not TXDataDSUtils.ResolvedAsExpected(lInfo, lXData.EntitySetName, lMessage) then
            raise Exception.Create(lMessage);

          if FLastSavedDonorId <= 0 then
            FLastSavedDonorId := InsertedDonorIdFromResolve(lInfo);
        finally
          FSuppressApplyUpdatesEvent := False;
        end;
      end;

      lSaveSucceeded := True;
      FListRefreshNeeded := True;
    except
      on E: Exception do
      begin
        WaitMessage.Hide;
        ShowMessage('Save failed: ' + E.Message);
      end;
    end;

    if lSaveSucceeded then
    begin
      FAddingNewDonor := False;
      if ShouldEnterLockedViewAfterSave then
        await(EnterLockedViewModeAfterSave);
      FinalizeLockedViewButtons;
    end
    else if EffectiveDonorId > 0 then
    begin
      try
        await(ReloadDonorFromServer);
      except
        on E: Exception do
          ShowMessage(E.Message);
      end;
      if CanUseEditToggle then
        EnterLockedViewMode;
    end;
  finally
    EndDonorSaveInProgress;
  end;
end;

function TDonorEditForm.DonorSaveActive: Boolean;
begin
  Result := FDonorSaveInProgress or SaveInProgress;
end;

function TDonorEditForm.DonorDatasetReady: Boolean;
begin
  Result := Assigned(DonorDataset) and DonorDataset.Active;
end;

procedure TDonorEditForm.BeginDonorSaveInProgress;
begin
  FDonorSaveInProgress := True;
  SetSaveInProgressUI(True);
end;

procedure TDonorEditForm.EndDonorSaveInProgress;
begin
  FDonorSaveInProgress := False;
  SetSaveInProgressUI(False);
end;

[async]
procedure TDonorEditForm.EnterLockedViewModeAfterSave; async;
begin
  await(ReloadDonorFromServer);
  EnterLockedViewMode;
end;

procedure TDonorEditForm.CancelButtonClick(Sender: TObject);
begin
  if DonorSaveActive then
    Exit;

  if FAddingNewDonor then
  begin
    ModalResult := mrCancel;
    Exit;
  end;

  if FLockedViewMode then
  begin
    ModalResult := mrCancel;
    Exit;
  end;

  if not FAddingNewDonor and not FLockedViewMode then
  begin
    if Assigned(DataSource.DataSet) and (DataSource.DataSet.State in dsEditModes) then
      DataSource.DataSet.Cancel;
    EnterLockedViewMode;
    Exit;
  end;

  ModalResult := mrCancel;
end;

function TDonorEditForm.SaveDescription: string;
begin
  UpdateDonorNames;
  case FLastActionState of
    dsEdit:
      result := 'Your changes for ' + DisplayName + ' have been saved';
    dsInsert:
      result := DisplayName + ' has been added.';
  else
    result := inherited;
  end;
end;

procedure TDonorEditForm.SetSaveInProgressUI(const AInProgress: Boolean);
begin
  inherited;

  if FLockedViewMode then
  begin
    if not AInProgress then
      SetPrimaryActionButton('Edit');
    Exit;
  end;

  if AInProgress then
  begin
    SetFormEditable(False);
    DeclarationsButton.Enabled := False;
    DefaultsButton.Enabled := False;
  end
  else
  begin
    DeclarationsButton.Enabled := True;
    DefaultsButton.Enabled := True;

    if FAddingNewDonor or not FLockedViewMode then
      CancelButton.Caption := 'Cancel'
    else
      CancelButton.Caption := 'Close';

    if LastServerSaveSucceeded and CanUseEditToggle then
      SetFormEditable(False)
    else
    begin
      SetFormEditable(True);
      CheckValidation;
    end;
  end;
end;

procedure TDonorEditForm.RecordChanged;
begin
  if FLockedViewMode or DonorSaveActive then
    Exit;

  inherited;
  UpdateCancelButtonCaption;
end;

procedure TDonorEditForm.DataSourceStateChange(Sender: TObject);
begin
  inherited DataSourceStateChange(Sender);
  UpdateCancelButtonCaption;

  if FLockedViewMode then
    FinalizeLockedViewButtons;
end;

function TDonorEditForm.CloseOnSave: boolean;
begin
  Result := False;
end;

procedure TDonorEditForm.UpdateCancelButtonCaption;
begin
  if FAddingNewDonor then
    CancelButton.Caption := 'Cancel'
  else if FLockedViewMode then
    CancelButton.Caption := 'Close'
  else
    CancelButton.Caption := 'Cancel';
end;

function TDonorEditForm.SaveTitle: string;
begin
  UpdateDonorNames;
  case FLastActionState of
    dsEdit:
      result := 'Changes for ' + DisplayName;
    dsInsert:
      result := DisplayName + ' Added';
  else
    result := DisplayName;
  end;
end;


procedure TDonorEditForm.SetPostCodeValidation(bValid: boolean);
begin
  CheckValidation;
end;

procedure TDonorEditForm.EditChange(Sender: TObject);
begin
  CheckValidation;
end;

procedure TDonorEditForm.ValidatePostCode;
var
  lCountry: string;
begin
  lCountry := CountryList.Text;
  if Pos('United Kingdom', lCountry) > 0 then
  begin
    if Length(edPostCode.Text) > 5 then
    begin
      if (Trim(edPostCode.Text) = '') then
      begin
        TDocUtils.setControlValidity('PostCode', vsInvalid);
        Exit;
      end;

      edPostCode.Text := TCRMUtils.FormatPostCode(edPostCode.Text);

      if TCRMUtils.IsPostCode(edPostCode.Text) <> pcFull then
      begin
        TDocUtils.setControlValidity('PostCode', vsInvalid);
        Exit;
      end;
      TDocUtils.setControlValidity('PostCode', vsValid);
    end
    else
    begin
      TDocUtils.setControlValidity('PostCode', vsInvalid);
    end
  end
  else
  begin
    edPostCode.Text := '';
  end;

  CheckValidation;
end;



procedure TDonorEditForm.DeclarationsButtonClick(Sender: TObject);
begin
  ShowDeclarations;
end;

procedure TDonorEditForm.WebFormCreate(Sender: TObject);
begin
  inherited;
  FAddingNewDonor := False;
  FEnterLockedViewAfterSetDataset := False;
  FEnterEditAfterSetDataset := False;
  CountryList.Items.Add(TCountryUtils.UNKNOWN);
  InitAttributesForm;
  TDonationUIUtils.AddDonorClaimStatusLookupsCombo(ClaimStatus.LookupValues);
  TDonationUIUtils.AddDonorKindLookupsToCombo(DonorKind.LookupValues);
  TrapEnterPressSetUp;

end;

procedure TDonorEditForm.WebFormShow(Sender: TObject);
begin
  CheckClaimStatusIsOther;
  FClaimStatusValid := False;

  if FAddingNewDonor then
  begin
    ApplyNewDonorSessionUI;
    edFirstName.SetFocus;
  end
  else if not CanUseEditToggle then
  begin
    UpdatePrimaryActionEnabled(False);
    FinalizeLockedViewButtons;
    edFirstName.SetFocus;
  end;
end;

procedure TDonorEditForm.SetLookUpValues(const AName: string; Value: TLookupValues);
begin
end;

function TDonorEditForm.CanUseEditToggle: Boolean;
begin
  Result := (RecordViewOption in [voEdit, voCreateAndEdit]) and DonorDatasetReady and
    (DataSource.DataSet.State <> dsInsert);
end;

procedure TDonorEditForm.SetFormEditable(const AEditable: Boolean);
begin
  edFirstName.Enabled := AEditable;
  edLastName.Enabled := AEditable;
  edAdd1.Enabled := AEditable;
  edAdd2.Enabled := AEditable;
  edAdd3.Enabled := AEditable;
  edCity.Enabled := AEditable;
  edPostCode.Enabled := AEditable;
  edCounty.Enabled := AEditable;
  edEmail.Enabled := AEditable;
  edMobile.Enabled := AEditable;
  edTelephone.Enabled := AEditable;
  ClaimStatus.Enabled := AEditable;
  Comments.Enabled := AEditable;
  ContactByPhone.Enabled := AEditable;
  ContactByEmail.Enabled := AEditable;
  ContactByText.Enabled := AEditable;
  ContactByPost.Enabled := AEditable;
  TitleEdit.Enabled := AEditable;
  ExternalIdEdit.Enabled := AEditable;
  CountryList.Enabled := AEditable;
  DonorCommentMemo.Enabled := AEditable;
  OrganisationName.Enabled := AEditable;
  DonorKind.Enabled := AEditable;
  DateOfDeath.Enabled := AEditable;
end;

procedure TDonorEditForm.SetPrimaryActionButton(const ACaption: string);
begin
  // Icon is supplied by global CSS based on SaveButton aria-label.
  SaveButton.Caption := ACaption;
  if Assigned(SaveButton.ElementHandle) then
    SaveButton.ElementHandle.setAttribute('aria-label', ACaption);
end;

procedure TDonorEditForm.UpdatePrimaryActionEnabled(const ACanSaveInEditMode: Boolean);
begin
  if DonorSaveActive then
  begin
    SaveButton.Enabled := False;
    Exit;
  end;

  if FLockedViewMode then
    SaveButton.Enabled := CanUseEditToggle
  else
    SaveButton.Enabled := ACanSaveInEditMode;
end;

procedure TDonorEditForm.EnterLockedViewMode;
begin
  if FAddingNewDonor or (Assigned(DataSource.DataSet) and (DataSource.DataSet.State = dsInsert)) then
    Exit;

  FLockedViewMode := True;
  DataSource.AutoEdit := False;
  if Assigned(DataSource.DataSet) and DataSource.DataSet.Active and
    (DataSource.DataSet.State in dsEditModes) then
    DataSource.DataSet.Cancel;
  SetFormEditable(False);
  SaveButton.Visible := True;
  SetPrimaryActionButton('Edit');
  UpdateCancelButtonCaption;
  DataState.HTML.Text := 'Viewing';
  FinalizeLockedViewButtons;
end;

procedure TDonorEditForm.FinalizeLockedViewButtons;
var
  lHasPersistedId: Boolean;
begin
  WaitMessage.Hide;
  CancelButton.Enabled := True;
  lHasPersistedId := Assigned(DataSource.DataSet) and DataSource.DataSet.Active and
    Assigned(DataSource.DataSet.FindField('Id')) and
    (DataSource.DataSet.FieldByName('Id').AsString <> '');
  DefaultsButton.Enabled := lHasPersistedId;
  DeclarationsButton.Enabled := DefaultsButton.Enabled;
  if FLockedViewMode then
  begin
    SetPrimaryActionButton('Edit');
    SaveButton.Enabled := CanUseEditToggle;
  end
  else
    UpdatePrimaryActionEnabled(False);
end;

procedure TDonorEditForm.ApplyEditSessionUI;
begin
  FLockedViewMode := False;
  DataSource.AutoEdit := True;
  SetFormEditable(True);
  SaveButton.Visible := True;
  SetPrimaryActionButton('Save');
  UpdatePrimaryActionEnabled(False);
  UpdateCancelButtonCaption;
  CancelButton.Enabled := True;
  if DonorDatasetReady and not (DataSource.DataSet.State in dsEditModes) then
    DataSource.DataSet.Edit;
  CheckValidation;
end;

procedure TDonorEditForm.ApplyNewDonorSessionUI;
begin
  FLockedViewMode := False;
  DataSource.AutoEdit := True;
  SetFormEditable(True);
  SaveButton.Visible := True;
  SetPrimaryActionButton('Save');
  DefaultsButton.Enabled := False;
  DeclarationsButton.Enabled := False;
  UpdatePrimaryActionEnabled(False);
  UpdateCancelButtonCaption;
  CancelButton.Enabled := True;
  CheckValidation;
end;

[async]
procedure TDonorEditForm.EnterEditMode; async;
begin
  if EffectiveDonorId > 0 then
    await(ReloadDonorFromServer);

  ApplyEditSessionUI;
end;

procedure TDonorEditForm.InitAttributesForm;
  procedure AfterAttributeFormCreated(AForm: TObject);
  begin
    TEssentialsAttributesForm(AForm).EntityClassName := 'TDonor';
  end;
begin{InitAttributesForm}

  Application.CreateForm(TEssentialsAttributesForm, 'essentials.attributes.container', FAttributesForm, @AfterAttributeFormCreated);
end;

procedure TDonorEditForm.OrganisationNameChange(Sender: TObject);
begin
  CheckValidation;
end;

procedure TDonorEditForm.OrganisationNameExit(Sender: TObject);
begin
  inherited;
  FormCaption.Caption := DisplayName;
end;

procedure TDonorEditForm.SetCountryCode;
var
  lCountryCode: string;
begin
  if FLockedViewMode then
    Exit;

  lCountryCode := TCountryUtils.GetCountryCodeFromCountryHelper(CountryList.Text);

  if not (DataSet.State in dsEditModes) then
    Dataset.Edit;


  Dataset.FieldByName('CountryCode').AsString := lCountryCode;

  if CountryList.ItemIndex > -1 then
    TDocUtils.setControlValidity('CountryList', vsValid)
  else
    TDocUtils.setControlValidity('CountryList', vsInvalid);

  ValidatePostCode;
end;

procedure TDonorEditForm.SetCountryToCountryCode(ACountryCode: string);
var
  lCountry: string;
begin
  if ACountryCode <> '' then
  begin
    lCountry := TCountryUtils.GetCountryFromCountryCodeHelper(ACountryCode);
    CountryList.Text := lCountry;
  end;
end;

procedure TDonorEditForm.edFirstNameExit(Sender: TObject);
begin
  if edFirstName.Text <> '' then
    TDocUtils.setControlValidity('FirstName', vsValid)
  else
    TDocUtils.setControlValidity('FirstName', vsInvalid);
  CheckValidation;
end;

procedure TDonorEditForm.edLastNameExit(Sender: TObject);
begin
  if edLastName.Text <> '' then
    TDocUtils.setControlValidity('LastName', vsValid)
  else
    TDocUtils.setControlValidity('LastName', vsInvalid);
  CheckValidation;
end;

procedure TDonorEditForm.edAdd1Exit(Sender: TObject);
begin
  ValidatePostCode;
  CheckValidation;
end;

procedure TDonorEditForm.ClaimStatusExit(Sender: TObject);
begin
  if ClaimStatus.ItemIndex > -1 then
  begin
    TDocUtils.setControlValidity('ClaimStatus', vsValid);
    FClaimStatusValid := True;
  end
  else
  begin
    TDocUtils.setControlValidity('ClaimStatus', vsInvalid);
    FClaimStatusValid := False;
  end;
  ClearDateOfDeathIfNotDeceased;
  UpdateDateOfDeathVisibility;
end;

procedure TDonorEditForm.DateOfDeathExit(Sender: TObject);
begin
  if DataSource.DataSet.State in dsEditModes then
    SyncDateOfDeathToDataset;
end;

procedure TDonorEditForm.CheckValidation;
var
  lDonorNameOk: boolean;
begin
  if (DonorKind.Value = 'Individual') or (DonorKind.Value = '')  then
  begin
    TDocUtils.ShowHideElement('FirstNameRequiredSVG', True);
    TDocUtils.ShowHideElement('LastNameRequiredSVG', True);
    TDocUtils.ShowHideElement('OrganisationNameRequiredSVG', False);
  end
  else
  begin
    TDocUtils.ShowHideElement('FirstNameRequiredSVG', False);
    TDocUtils.ShowHideElement('LastNameRequiredSVG', False);
    TDocUtils.ShowHideElement('OrganisationNameRequiredSVG', True);
  end;

  if ((edFirstName.Text <> '') and (edLastName.Text <> '')) and (DonorKind.Value = zIndividual) or
     (organisationName.Text <> '') and ((DonorKind.Value = zCompany) or (DonorKind.Value = 'Charity')) then
    lDonorNameOk := true
  else
    lDonorNameOk := false;


  UpdatePrimaryActionEnabled(
    FClaimStatusValid and (lDonorNameOk = True) and (DonorKind.ItemIndex > -1)
  );

  CheckClaimStatus;
end;

procedure TDonorEditForm.DefaultsButtonClick(Sender: TObject);
begin
  ShowDefaults;
end;

procedure TDonorEditForm.ShowDefaults;
var
  lId: integer;
  AForm: TDonationDefaultsForm;
begin
  lId := Dataset.FieldByName('Id').AsInteger;
  AForm := TDonationDefaultsForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';

    await(TForm, AForm.Load());

    AForm.DonorId := lId;
    AForm.AfterCreated;
    await(TModalResult, AForm.Execute);
  finally
    AForm.Free;
    AForm := nil;
  end;
end;

procedure TDonorEditForm.UpdateDonorNames;
begin
  if not DonorDatasetReady then
    Exit;

  FExistingDonorNames.OrganisationName := Dataset.FieldByName('OrganisationName').AsString;
  FExistingDonorNames.FirstNameLastName :=
    Datasource.Dataset.FieldByName('FirstName').AsString + ' ' +
    Datasource.Dataset.FieldByName('LastName').AsString;

  FormCaption.Caption := DisplayName;
end;

procedure TDonorEditForm.ShowDeclarations;
var
  lId: integer;
  AForm: TDonorDeclarationsForm;
  lUpdateDonorStatus: boolean;
begin
  lId := Dataset.FieldByName('Id').AsInteger;
  AForm := TDonorDeclarationsForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';

    await(TForm, AForm.Load());
    //AForm.LoadData;
    AForm.DonorId := lId;
    AForm.DonationDate := 0;
    AForm.AfterCreated;
    await(TModalResult, AForm.Execute);
  finally
    //lNewDeclaration := AForm.NewDeclaration;
    lUpdateDonorStatus := AForm.SetStatusOk;
    AForm.Free;
    AForm := nil;

    //The actual UPDATE to the Donor Status to OK is done in the service
    if lUpdateDonorStatus then // and (Dataset.FieldByName('ClaimStatus').AsString <> 'Ok') then
      ClaimStatus.ItemIndex := 0;
  end;
end;

procedure TDonorEditForm.ResolveDonorType;
begin
  if Datasource.Dataset.FieldByName('DonorKind').AsString = zIndividual then
    Datasource.DataSet.FieldByName('OrganisationName').AsString := ''
  else
  begin
    Datasource.Dataset.FieldByName('Title').AsString := '';
    Datasource.Dataset.FieldByName('FirstName').AsString := '';
    Datasource.Dataset.FieldByName('LastName').AsString := '';
  end;
end;

procedure TDonorEditForm.CheckClaimStatus;
var
  LErrorText: string;
begin
  if Uppercase(ClaimStatus.DisplayText) = 'OK' then
  begin
    if not TGARulesUtils.DonorMeetsGiftAidRequirements(DonorKind.Value, ClaimStatus.Value, edAdd1.Text,
      edPostCode.Text, 0, 0, LErrorText) then
    begin
      if Dataset.State = dsEdit then
        Dataset.FieldByName('ClaimStatus').AsString := 'NoActiveGiftAid';
    end;
  end;
end;

procedure TDonorEditForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  DonorIdLabel := TDBLabel.Create('DonorIdLabel');
  ExternalIdLabel := TDBLabel.Create('ExternalIdLabel');
  edFirstName := TDBEdit.Create('FirstName');
  edLastName := TDBEdit.Create('LastName');
  edAdd1 := TDBEdit.Create('Add1');
  edAdd2 := TDBEdit.Create('Add2');
  edAdd3 := TDBEdit.Create('Add3');
  edCity := TDBEdit.Create('City');
  edEmail := TDBEdit.Create('Email');
  edMobile := TDBEdit.Create('Mobile');
  edTelephone := TDBEdit.Create('Phone');
  ClaimStatus := TDBLookupComboBox.Create('ClaimStatus');
  Comments := TDBEdit.Create('Comments');
  ContactByPhone := TDBCheckBox.Create('ContactByPhone');
  ContactByEmail := TDBCheckBox.Create('ContactByEmail');
  ContactByText := TDBCheckBox.Create('ContactByText');
  ContactByPost := TDBCheckBox.Create('ContactByPost');
  TitleEdit := TDBEdit.Create('Title');
  ExternalIdEdit := TDBEdit.Create('ExternalIdEdit');
  edCounty := TDBEdit.Create('CountyEdit');
  CountryList := TCountryComboBox.Create('CountryList');
  DefaultsButton := TButton.Create('DefaultsButton');
  DeclarationsButton := TButton.Create('DeclarationsButton');
  DonorCommentMemo := TDBMemo.Create('DonorCommentMemo');
  OrganisationName := TDBEdit.Create('OrganisationName');
  DonorKind := TDBLookupComboBox.Create('DonorKind');
  DateOfDeath := TDBDateTimePicker.Create('DateOfDeath');
  edPostCode := TEdit.Create('PostCode');
  DonorDataset := TXDataWebDataSet.Create(Self);
  DonorDatasetId := TIntegerField.Create(Self);
  DonorDatasetDateAdded := TDateTimeField.Create(Self);
  DonorDatasetAddedBy := TIntegerField.Create(Self);
  DonorDatasetLastUpdatedBy := TIntegerField.Create(Self);
  DonorDatasetLastUpdated := TDateTimeField.Create(Self);
  DonorDatasetTitle := TStringField.Create(Self);
  DonorDatasetFirstName := TStringField.Create(Self);
  DonorDatasetMiddleName := TStringField.Create(Self);
  DonorDatasetLastName := TStringField.Create(Self);
  DonorDatasetSuffix := TStringField.Create(Self);
  DonorDatasetAdd1 := TStringField.Create(Self);
  DonorDatasetAdd2 := TStringField.Create(Self);
  DonorDatasetAdd3 := TStringField.Create(Self);
  DonorDatasetCity := TStringField.Create(Self);
  DonorDatasetPostCode := TStringField.Create(Self);
  DonorDatasetEmail := TStringField.Create(Self);
  DonorDatasetMobile := TStringField.Create(Self);
  DonorDatasetTelephone := TStringField.Create(Self);
  DonorDatasetMatchHash := TStringField.Create(Self);
  DonorDatasetVersion := TIntegerField.Create(Self);
  DonorDatasetContactByPhone := TBooleanField.Create(Self);
  DonorDatasetContactByPost := TBooleanField.Create(Self);
  DonorDatasetContactByText := TBooleanField.Create(Self);
  DonorDatasetContactByEmail := TBooleanField.Create(Self);
  DonorDatasetDOB := TDateField.Create(Self);
  DonorDatasetHearingStatus := TStringField.Create(Self);
  DonorDatasetEmailStatus := TStringField.Create(Self);
  DonorDatasetLatitude := TFloatField.Create(Self);
  DonorDatasetLongitude := TFloatField.Create(Self);
  DonorDatasetExternalId := TStringField.Create(Self);
  DonorDatasetCountryCode := TStringField.Create(Self);
  DonorDatasetVisualStatus := TStringField.Create(Self);
  DonorDatasetMobilityStatus := TStringField.Create(Self);
  DonorDatasetSourceType := TStringField.Create(Self);
  DonorDatasetClaimStatus := TStringField.Create(Self);
  DonorDatasetCharityTenant := TStringField.Create(Self);
  DonorDatasetComments := TStringField.Create(Self);
  DonorDatasetImportId := TIntegerField.Create(Self);
  DonorDatasetCounty := TStringField.Create(Self);
  DonorDatasetLocationType := TStringField.Create(Self);
  DonorDatasetOrganisationName := TStringField.Create(Self);
  DonorDatasetDonorKind := TStringField.Create(Self);
  DonorDatasetDateOfDeath := TDateTimeField.Create(Self);

  DonorIdLabel.BeforeLoadDFMValues;
  ExternalIdLabel.BeforeLoadDFMValues;
  CancelButton.BeforeLoadDFMValues;
  SaveButton.BeforeLoadDFMValues;
  edFirstName.BeforeLoadDFMValues;
  edLastName.BeforeLoadDFMValues;
  edAdd1.BeforeLoadDFMValues;
  edAdd2.BeforeLoadDFMValues;
  edAdd3.BeforeLoadDFMValues;
  edCity.BeforeLoadDFMValues;
  edEmail.BeforeLoadDFMValues;
  edMobile.BeforeLoadDFMValues;
  edTelephone.BeforeLoadDFMValues;
  ClaimStatus.BeforeLoadDFMValues;
  Comments.BeforeLoadDFMValues;
  ContactByPhone.BeforeLoadDFMValues;
  ContactByEmail.BeforeLoadDFMValues;
  ContactByText.BeforeLoadDFMValues;
  ContactByPost.BeforeLoadDFMValues;
  DataState.BeforeLoadDFMValues;
  TitleEdit.BeforeLoadDFMValues;
  ExternalIdEdit.BeforeLoadDFMValues;
  edCounty.BeforeLoadDFMValues;
  CountryList.BeforeLoadDFMValues;
  DefaultsButton.BeforeLoadDFMValues;
  DeclarationsButton.BeforeLoadDFMValues;
  DonorCommentMemo.BeforeLoadDFMValues;
  OrganisationName.BeforeLoadDFMValues;
  DonorKind.BeforeLoadDFMValues;
  DateOfDeath.BeforeLoadDFMValues;
  edPostCode.BeforeLoadDFMValues;
  DonorDataset.BeforeLoadDFMValues;
  DonorDatasetId.BeforeLoadDFMValues;
  DonorDatasetDateAdded.BeforeLoadDFMValues;
  DonorDatasetAddedBy.BeforeLoadDFMValues;
  DonorDatasetLastUpdatedBy.BeforeLoadDFMValues;
  DonorDatasetLastUpdated.BeforeLoadDFMValues;
  DonorDatasetTitle.BeforeLoadDFMValues;
  DonorDatasetFirstName.BeforeLoadDFMValues;
  DonorDatasetMiddleName.BeforeLoadDFMValues;
  DonorDatasetLastName.BeforeLoadDFMValues;
  DonorDatasetSuffix.BeforeLoadDFMValues;
  DonorDatasetAdd1.BeforeLoadDFMValues;
  DonorDatasetAdd2.BeforeLoadDFMValues;
  DonorDatasetAdd3.BeforeLoadDFMValues;
  DonorDatasetCity.BeforeLoadDFMValues;
  DonorDatasetPostCode.BeforeLoadDFMValues;
  DonorDatasetEmail.BeforeLoadDFMValues;
  DonorDatasetMobile.BeforeLoadDFMValues;
  DonorDatasetTelephone.BeforeLoadDFMValues;
  DonorDatasetMatchHash.BeforeLoadDFMValues;
  DonorDatasetVersion.BeforeLoadDFMValues;
  DonorDatasetContactByPhone.BeforeLoadDFMValues;
  DonorDatasetContactByPost.BeforeLoadDFMValues;
  DonorDatasetContactByText.BeforeLoadDFMValues;
  DonorDatasetContactByEmail.BeforeLoadDFMValues;
  DonorDatasetDOB.BeforeLoadDFMValues;
  DonorDatasetHearingStatus.BeforeLoadDFMValues;
  DonorDatasetEmailStatus.BeforeLoadDFMValues;
  DonorDatasetLatitude.BeforeLoadDFMValues;
  DonorDatasetLongitude.BeforeLoadDFMValues;
  DonorDatasetExternalId.BeforeLoadDFMValues;
  DonorDatasetCountryCode.BeforeLoadDFMValues;
  DonorDatasetVisualStatus.BeforeLoadDFMValues;
  DonorDatasetMobilityStatus.BeforeLoadDFMValues;
  DonorDatasetSourceType.BeforeLoadDFMValues;
  DonorDatasetClaimStatus.BeforeLoadDFMValues;
  DonorDatasetCharityTenant.BeforeLoadDFMValues;
  DonorDatasetComments.BeforeLoadDFMValues;
  DonorDatasetImportId.BeforeLoadDFMValues;
  DonorDatasetCounty.BeforeLoadDFMValues;
  DonorDatasetLocationType.BeforeLoadDFMValues;
  DonorDatasetOrganisationName.BeforeLoadDFMValues;
  DonorDatasetDonorKind.BeforeLoadDFMValues;
  DonorDatasetDateOfDeath.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  CloseTimer.BeforeLoadDFMValues;
  try
    Width := 900;
    Height := 508;
    Caption := 'MainData.DummySource';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    DonorIdLabel.SetParentComponent(Self);
    DonorIdLabel.Name := 'DonorIdLabel';
    DonorIdLabel.Left := 232;
    DonorIdLabel.Top := 27;
    DonorIdLabel.Width := 71;
    DonorIdLabel.Height := 15;
    DonorIdLabel.Caption := 'DonorIdLabel';
    DonorIdLabel.ElementLabelClassName := 'form-control-manual';
    DonorIdLabel.ElementFont := efCSS;
    DonorIdLabel.HeightStyle := ssAuto;
    DonorIdLabel.HeightPercent := 100.000000000000000000;
    DonorIdLabel.WidthPercent := 100.000000000000000000;
    DonorIdLabel.DataField := 'Id';
    DonorIdLabel.DataSource := DataSource;
    ExternalIdLabel.SetParentComponent(Self);
    ExternalIdLabel.Name := 'ExternalIdLabel';
    ExternalIdLabel.Left := 232;
    ExternalIdLabel.Top := 46;
    ExternalIdLabel.Width := 79;
    ExternalIdLabel.Height := 15;
    ExternalIdLabel.Caption := 'ExternalIdLabel';
    ExternalIdLabel.ElementLabelClassName := 'form-control-manual';
    ExternalIdLabel.ElementFont := efCSS;
    ExternalIdLabel.HeightStyle := ssAuto;
    ExternalIdLabel.HeightPercent := 100.000000000000000000;
    ExternalIdLabel.WidthStyle := ssAuto;
    ExternalIdLabel.WidthPercent := 100.000000000000000000;
    ExternalIdLabel.DataField := 'ExternalId';
    ExternalIdLabel.DataSource := DataSource;
    CancelButton.Left := 192;
    CancelButton.Top := 398;
    CancelButton.TabOrder := 22;
    SaveButton.Left := 24;
    SaveButton.Top := 398;
    SaveButton.TabOrder := 21;
    edFirstName.SetParentComponent(Self);
    edFirstName.Name := 'edFirstName';
    edFirstName.Left := 24;
    edFirstName.Top := 161;
    edFirstName.Width := 200;
    edFirstName.Height := 21;
    edFirstName.AutoCompletion := acNone;
    edFirstName.AutoSelect := False;
    edFirstName.ChildOrder := 9;
    edFirstName.ElementClassName := 'form-control';
    edFirstName.ElementFont := efCSS;
    edFirstName.ElementPosition := epIgnore;
    edFirstName.HeightStyle := ssAuto;
    edFirstName.HeightPercent := 100.000000000000000000;
    edFirstName.TabOrder := 2;
    edFirstName.Text := 'edFirstName';
    edFirstName.WidthStyle := ssAuto;
    edFirstName.WidthPercent := 100.000000000000000000;
    SetEvent(edFirstName, Self, 'OnChange', 'edFirstNameExit');
    edFirstName.DataField := 'FirstName';
    edFirstName.DataSource := DataSource;
    edLastName.SetParentComponent(Self);
    edLastName.Name := 'edLastName';
    edLastName.Left := 24;
    edLastName.Top := 188;
    edLastName.Width := 200;
    edLastName.Height := 21;
    edLastName.AutoCompletion := acNone;
    edLastName.AutoSelect := False;
    edLastName.ChildOrder := 10;
    edLastName.ElementClassName := 'form-control';
    edLastName.ElementFont := efCSS;
    edLastName.ElementPosition := epIgnore;
    edLastName.HeightStyle := ssAuto;
    edLastName.HeightPercent := 100.000000000000000000;
    edLastName.TabOrder := 3;
    edLastName.Text := 'edLastName';
    edLastName.WidthStyle := ssAuto;
    edLastName.WidthPercent := 100.000000000000000000;
    SetEvent(edLastName, Self, 'OnChange', 'edLastNameExit');
    SetEvent(edLastName, Self, 'OnExit', 'edLastNameExit');
    edLastName.DataField := 'LastName';
    edLastName.DataSource := DataSource;
    edAdd1.SetParentComponent(Self);
    edAdd1.Name := 'edAdd1';
    edAdd1.Left := 253;
    edAdd1.Top := 91;
    edAdd1.Width := 200;
    edAdd1.Height := 21;
    edAdd1.AutoCompletion := acNone;
    edAdd1.AutoSelect := False;
    edAdd1.ChildOrder := 11;
    edAdd1.ElementClassName := 'form-control';
    edAdd1.ElementFont := efCSS;
    edAdd1.ElementPosition := epIgnore;
    edAdd1.HeightStyle := ssAuto;
    edAdd1.HeightPercent := 100.000000000000000000;
    edAdd1.TabOrder := 4;
    edAdd1.Text := 'edAdd1';
    edAdd1.WidthStyle := ssAuto;
    edAdd1.WidthPercent := 100.000000000000000000;
    SetEvent(edAdd1, Self, 'OnChange', 'edAdd1Exit');
    SetEvent(edAdd1, Self, 'OnExit', 'edAdd1Exit');
    edAdd1.DataField := 'Add1';
    edAdd1.DataSource := DataSource;
    edAdd2.SetParentComponent(Self);
    edAdd2.Name := 'edAdd2';
    edAdd2.Left := 253;
    edAdd2.Top := 118;
    edAdd2.Width := 200;
    edAdd2.Height := 21;
    edAdd2.AutoCompletion := acNone;
    edAdd2.AutoSelect := False;
    edAdd2.ChildOrder := 12;
    edAdd2.ElementClassName := 'form-control';
    edAdd2.ElementFont := efCSS;
    edAdd2.ElementPosition := epIgnore;
    edAdd2.HeightStyle := ssAuto;
    edAdd2.HeightPercent := 100.000000000000000000;
    edAdd2.TabOrder := 5;
    edAdd2.Text := 'edAdd2';
    edAdd2.WidthStyle := ssAuto;
    edAdd2.WidthPercent := 100.000000000000000000;
    SetEvent(edAdd2, Self, 'OnChange', 'EditChange');
    edAdd2.DataField := 'Add2';
    edAdd2.DataSource := DataSource;
    edAdd3.SetParentComponent(Self);
    edAdd3.Name := 'edAdd3';
    edAdd3.Left := 253;
    edAdd3.Top := 145;
    edAdd3.Width := 200;
    edAdd3.Height := 21;
    edAdd3.AutoCompletion := acNone;
    edAdd3.AutoSelect := False;
    edAdd3.ChildOrder := 13;
    edAdd3.ElementClassName := 'form-control';
    edAdd3.ElementFont := efCSS;
    edAdd3.ElementPosition := epIgnore;
    edAdd3.HeightStyle := ssAuto;
    edAdd3.HeightPercent := 100.000000000000000000;
    edAdd3.TabOrder := 6;
    edAdd3.Text := 'edAdd3';
    edAdd3.WidthStyle := ssAuto;
    edAdd3.WidthPercent := 100.000000000000000000;
    SetEvent(edAdd3, Self, 'OnChange', 'EditChange');
    edAdd3.DataField := 'Add3';
    edAdd3.DataSource := DataSource;
    edCity.SetParentComponent(Self);
    edCity.Name := 'edCity';
    edCity.Left := 253;
    edCity.Top := 171;
    edCity.Width := 200;
    edCity.Height := 21;
    edCity.AutoCompletion := acNone;
    edCity.AutoSelect := False;
    edCity.ChildOrder := 14;
    edCity.ElementClassName := 'form-control';
    edCity.ElementFont := efCSS;
    edCity.ElementPosition := epIgnore;
    edCity.HeightStyle := ssAuto;
    edCity.HeightPercent := 100.000000000000000000;
    edCity.TabOrder := 7;
    edCity.Text := 'edCity';
    edCity.WidthStyle := ssAuto;
    edCity.WidthPercent := 100.000000000000000000;
    SetEvent(edCity, Self, 'OnChange', 'EditChange');
    edCity.DataField := 'City';
    edCity.DataSource := DataSource;
    edEmail.SetParentComponent(Self);
    edEmail.Name := 'edEmail';
    edEmail.Left := 24;
    edEmail.Top := 217;
    edEmail.Width := 200;
    edEmail.Height := 21;
    edEmail.AutoCompletion := acNone;
    edEmail.AutoSelect := False;
    edEmail.CharCase := wecLowerCase;
    edEmail.ChildOrder := 16;
    edEmail.ElementClassName := 'form-control';
    edEmail.ElementFont := efCSS;
    edEmail.ElementPosition := epIgnore;
    edEmail.HeightStyle := ssAuto;
    edEmail.HeightPercent := 100.000000000000000000;
    edEmail.TabOrder := 11;
    edEmail.Text := 'edEmail';
    edEmail.WidthStyle := ssAuto;
    edEmail.WidthPercent := 100.000000000000000000;
    SetEvent(edEmail, Self, 'OnChange', 'EditChange');
    edEmail.DataField := 'Email';
    edEmail.DataSource := DataSource;
    edMobile.SetParentComponent(Self);
    edMobile.Name := 'edMobile';
    edMobile.Left := 24;
    edMobile.Top := 244;
    edMobile.Width := 200;
    edMobile.Height := 21;
    edMobile.AutoCompletion := acNone;
    edMobile.AutoSelect := False;
    edMobile.ChildOrder := 17;
    edMobile.ElementClassName := 'form-control';
    edMobile.ElementFont := efCSS;
    edMobile.ElementPosition := epIgnore;
    edMobile.HeightStyle := ssAuto;
    edMobile.HeightPercent := 100.000000000000000000;
    edMobile.TabOrder := 10;
    edMobile.Text := 'edMobile';
    edMobile.WidthStyle := ssAuto;
    edMobile.WidthPercent := 100.000000000000000000;
    SetEvent(edMobile, Self, 'OnChange', 'EditChange');
    edMobile.DataField := 'Mobile';
    edMobile.DataSource := DataSource;
    edTelephone.SetParentComponent(Self);
    edTelephone.Name := 'edTelephone';
    edTelephone.Left := 24;
    edTelephone.Top := 271;
    edTelephone.Width := 200;
    edTelephone.Height := 21;
    edTelephone.AutoCompletion := acNone;
    edTelephone.AutoSelect := False;
    edTelephone.ChildOrder := 18;
    edTelephone.ElementClassName := 'form-control';
    edTelephone.ElementFont := efCSS;
    edTelephone.ElementPosition := epIgnore;
    edTelephone.HeightStyle := ssAuto;
    edTelephone.HeightPercent := 100.000000000000000000;
    edTelephone.TabOrder := 9;
    edTelephone.Text := 'edTelephone';
    edTelephone.WidthStyle := ssAuto;
    edTelephone.WidthPercent := 100.000000000000000000;
    SetEvent(edTelephone, Self, 'OnChange', 'EditChange');
    edTelephone.DataField := 'Telephone';
    edTelephone.DataSource := DataSource;
    ClaimStatus.SetParentComponent(Self);
    ClaimStatus.Name := 'ClaimStatus';
    ClaimStatus.Left := 256;
    ClaimStatus.Top := 268;
    ClaimStatus.Width := 197;
    ClaimStatus.Height := 22;
    ClaimStatus.ElementClassName := 'form-select form-control';
    ClaimStatus.ElementFont := efCSS;
    ClaimStatus.HeightPercent := 100.000000000000000000;
    ClaimStatus.TabOrder := 12;
    ClaimStatus.WidthPercent := 100.000000000000000000;
    SetEvent(ClaimStatus, Self, 'OnChange', 'ClaimStatusChange');
    SetEvent(ClaimStatus, Self, 'OnExit', 'ClaimStatusExit');
    ClaimStatus.DataField := 'ClaimStatus';
    ClaimStatus.DataSource := DataSource;
    ClaimStatus.ListSource := MainData.DummySource;
    Comments.SetParentComponent(Self);
    Comments.Name := 'Comments';
    Comments.Left := 472;
    Comments.Top := 224;
    Comments.Width := 121;
    Comments.Height := 22;
    Comments.AutoCompletion := acNone;
    Comments.AutoSelect := False;
    Comments.ChildOrder := 25;
    Comments.ElementClassName := 'form-control';
    Comments.ElementFont := efCSS;
    Comments.ElementPosition := epIgnore;
    Comments.HeightStyle := ssAuto;
    Comments.HeightPercent := 100.000000000000000000;
    Comments.TabOrder := 13;
    Comments.Text := 'Comments';
    Comments.Visible := False;
    Comments.WidthStyle := ssAuto;
    Comments.WidthPercent := 100.000000000000000000;
    SetEvent(Comments, Self, 'OnChange', 'EditChange');
    Comments.DataField := 'Comments';
    Comments.DataSource := DataSource;
    ContactByPhone.SetParentComponent(Self);
    ContactByPhone.Name := 'ContactByPhone';
    ContactByPhone.Left := 318;
    ContactByPhone.Top := 340;
    ContactByPhone.Width := 113;
    ContactByPhone.Height := 22;
    ContactByPhone.ChildOrder := 27;
    ContactByPhone.ElementClassName := 'form-check-input';
    ContactByPhone.ElementFont := efCSS;
    ContactByPhone.ElementPosition := epIgnore;
    ContactByPhone.HeightStyle := ssAuto;
    ContactByPhone.HeightPercent := 100.000000000000000000;
    ContactByPhone.TabOrder := 14;
    ContactByPhone.WidthStyle := ssAuto;
    ContactByPhone.WidthPercent := 100.000000000000000000;
    ContactByPhone.DataField := 'ContactByPhone';
    ContactByPhone.DataSource := DataSource;
    ContactByEmail.SetParentComponent(Self);
    ContactByEmail.Name := 'ContactByEmail';
    ContactByEmail.Left := 32;
    ContactByEmail.Top := 368;
    ContactByEmail.Width := 113;
    ContactByEmail.Height := 22;
    ContactByEmail.ChildOrder := 27;
    ContactByEmail.ElementClassName := 'form-check-input';
    ContactByEmail.ElementFont := efCSS;
    ContactByEmail.ElementPosition := epIgnore;
    ContactByEmail.HeightStyle := ssAuto;
    ContactByEmail.HeightPercent := 100.000000000000000000;
    ContactByEmail.TabOrder := 16;
    ContactByEmail.WidthStyle := ssAuto;
    ContactByEmail.WidthPercent := 100.000000000000000000;
    ContactByEmail.DataField := 'ContactByEmail';
    ContactByEmail.DataSource := DataSource;
    ContactByText.SetParentComponent(Self);
    ContactByText.Name := 'ContactByText';
    ContactByText.Left := 183;
    ContactByText.Top := 368;
    ContactByText.Width := 113;
    ContactByText.Height := 22;
    ContactByText.ChildOrder := 27;
    ContactByText.ElementClassName := 'form-check-input';
    ContactByText.ElementFont := efCSS;
    ContactByText.ElementPosition := epIgnore;
    ContactByText.HeightStyle := ssAuto;
    ContactByText.HeightPercent := 100.000000000000000000;
    ContactByText.TabOrder := 19;
    ContactByText.WidthStyle := ssAuto;
    ContactByText.WidthPercent := 100.000000000000000000;
    ContactByText.DataField := 'ContactByText';
    ContactByText.DataSource := DataSource;
    ContactByPost.SetParentComponent(Self);
    ContactByPost.Name := 'ContactByPost';
    ContactByPost.Left := 291;
    ContactByPost.Top := 368;
    ContactByPost.Width := 113;
    ContactByPost.Height := 22;
    ContactByPost.ChildOrder := 27;
    ContactByPost.ElementClassName := 'form-check-input';
    ContactByPost.ElementFont := efCSS;
    ContactByPost.ElementPosition := epIgnore;
    ContactByPost.HeightStyle := ssAuto;
    ContactByPost.HeightPercent := 100.000000000000000000;
    ContactByPost.TabOrder := 13;
    ContactByPost.WidthStyle := ssAuto;
    ContactByPost.WidthPercent := 100.000000000000000000;
    ContactByPost.DataField := 'ContactByPost';
    ContactByPost.DataSource := DataSource;
    DataState.Left := 10;
    DataState.Top := 66;
    TitleEdit.SetParentComponent(Self);
    TitleEdit.Name := 'TitleEdit';
    TitleEdit.Left := 24;
    TitleEdit.Top := 134;
    TitleEdit.Width := 200;
    TitleEdit.Height := 21;
    TitleEdit.AutoCompletion := acNone;
    TitleEdit.AutoSelect := False;
    TitleEdit.ChildOrder := 9;
    TitleEdit.ElementClassName := 'form-control';
    TitleEdit.ElementFont := efCSS;
    TitleEdit.ElementPosition := epIgnore;
    TitleEdit.HeightStyle := ssAuto;
    TitleEdit.HeightPercent := 100.000000000000000000;
    TitleEdit.TabOrder := 2;
    TitleEdit.Text := 'Title';
    TitleEdit.WidthStyle := ssAuto;
    TitleEdit.WidthPercent := 100.000000000000000000;
    SetEvent(TitleEdit, Self, 'OnChange', 'EditChange');
    TitleEdit.DataField := 'Title';
    TitleEdit.DataSource := DataSource;
    ExternalIdEdit.SetParentComponent(Self);
    ExternalIdEdit.Name := 'ExternalIdEdit';
    ExternalIdEdit.Left := 258;
    ExternalIdEdit.Top := 296;
    ExternalIdEdit.Width := 200;
    ExternalIdEdit.Height := 21;
    ExternalIdEdit.AutoCompletion := acNone;
    ExternalIdEdit.AutoSelect := False;
    ExternalIdEdit.CharCase := wecUpperCase;
    ExternalIdEdit.ChildOrder := 15;
    ExternalIdEdit.ElementClassName := 'form-control';
    ExternalIdEdit.ElementFont := efCSS;
    ExternalIdEdit.ElementPosition := epIgnore;
    ExternalIdEdit.HeightStyle := ssAuto;
    ExternalIdEdit.HeightPercent := 100.000000000000000000;
    ExternalIdEdit.TabOrder := 8;
    ExternalIdEdit.Text := 'ExternalIdEdit';
    ExternalIdEdit.WidthStyle := ssAuto;
    ExternalIdEdit.WidthPercent := 100.000000000000000000;
    SetEvent(ExternalIdEdit, Self, 'OnExit', 'edPostCodeXXXExit');
    ExternalIdEdit.DataField := 'ExternalId';
    ExternalIdEdit.DataSource := DataSource;
    edCounty.SetParentComponent(Self);
    edCounty.Name := 'edCounty';
    edCounty.Left := 472;
    edCounty.Top := 197;
    edCounty.Width := 200;
    edCounty.Height := 21;
    edCounty.AutoCompletion := acNone;
    edCounty.AutoSelect := False;
    edCounty.ChildOrder := 15;
    edCounty.ElementClassName := 'form-control';
    edCounty.ElementFont := efCSS;
    edCounty.ElementPosition := epIgnore;
    edCounty.HeightStyle := ssAuto;
    edCounty.HeightPercent := 100.000000000000000000;
    edCounty.TabOrder := 8;
    edCounty.Text := 'edCounty';
    edCounty.WidthStyle := ssAuto;
    edCounty.WidthPercent := 100.000000000000000000;
    SetEvent(edCounty, Self, 'OnChange', 'EditChange');
    edCounty.DataField := 'County';
    edCounty.DataSource := DataSource;
    CountryList.SetParentComponent(Self);
    CountryList.Name := 'CountryList';
    CountryList.Left := 253;
    CountryList.Top := 225;
    CountryList.Width := 200;
    CountryList.Height := 23;
    CountryList.ElementClassName := 'form-select';
    CountryList.ElementPosition := epIgnore;
    CountryList.HeightStyle := ssAuto;
    CountryList.HeightPercent := 100.000000000000000000;
    CountryList.WidthStyle := ssAuto;
    CountryList.WidthPercent := 100.000000000000000000;
    SetEvent(CountryList, Self, 'OnChange', 'CountryListChange');
    CountryList.ItemIndex := -1;
    DefaultsButton.SetParentComponent(Self);
    DefaultsButton.Name := 'DefaultsButton';
    DefaultsButton.Left := 192;
    DefaultsButton.Top := 448;
    DefaultsButton.Width := 144;
    DefaultsButton.Height := 38;
    DefaultsButton.Caption := 'Defaults';
    DefaultsButton.ChildOrder := 31;
    DefaultsButton.ElementClassName := 'btn btn-secondary';
    DefaultsButton.ElementPosition := epIgnore;
    DefaultsButton.HeightStyle := ssAuto;
    DefaultsButton.HeightPercent := 100.000000000000000000;
    DefaultsButton.WidthStyle := ssAuto;
    DefaultsButton.WidthPercent := 100.000000000000000000;
    SetEvent(DefaultsButton, Self, 'OnClick', 'DefaultsButtonClick');
    DeclarationsButton.SetParentComponent(Self);
    DeclarationsButton.Name := 'DeclarationsButton';
    DeclarationsButton.Left := 357;
    DeclarationsButton.Top := 448;
    DeclarationsButton.Width := 144;
    DeclarationsButton.Height := 38;
    DeclarationsButton.Caption := 'Declarations';
    DeclarationsButton.ChildOrder := 33;
    DeclarationsButton.ElementClassName := 'btn btn-secondary';
    DeclarationsButton.HeightPercent := 100.000000000000000000;
    DeclarationsButton.WidthPercent := 100.000000000000000000;
    SetEvent(DeclarationsButton, Self, 'OnClick', 'DeclarationsButtonClick');
    DonorCommentMemo.SetParentComponent(Self);
    DonorCommentMemo.Name := 'DonorCommentMemo';
    DonorCommentMemo.Left := 473;
    DonorCommentMemo.Top := 102;
    DonorCommentMemo.Width := 185;
    DonorCommentMemo.Height := 89;
    DonorCommentMemo.ElementClassName := 'form-control';
    DonorCommentMemo.ElementPosition := epIgnore;
    DonorCommentMemo.HeightStyle := ssAuto;
    DonorCommentMemo.HeightPercent := 100.000000000000000000;
    DonorCommentMemo.SelLength := 0;
    DonorCommentMemo.SelStart := 0;
    DonorCommentMemo.TabOrder := 26;
    DonorCommentMemo.WidthStyle := ssAuto;
    DonorCommentMemo.WidthPercent := 100.000000000000000000;
    DonorCommentMemo.DataField := 'Comments';
    DonorCommentMemo.DataSource := DataSource;
    OrganisationName.SetParentComponent(Self);
    OrganisationName.Name := 'OrganisationName';
    OrganisationName.Left := 728;
    OrganisationName.Top := 304;
    OrganisationName.Width := 121;
    OrganisationName.Height := 22;
    OrganisationName.ChildOrder := 37;
    OrganisationName.ElementPosition := epIgnore;
    OrganisationName.HeightStyle := ssAuto;
    OrganisationName.HeightPercent := 100.000000000000000000;
    OrganisationName.WidthStyle := ssAuto;
    OrganisationName.WidthPercent := 100.000000000000000000;
    SetEvent(OrganisationName, Self, 'OnChange', 'OrganisationNameChange');
    OrganisationName.DataField := 'OrganisationName';
    OrganisationName.DataSource := DataSource;
    DonorKind.SetParentComponent(Self);
    DonorKind.Name := 'DonorKind';
    DonorKind.Left := 728;
    DonorKind.Top := 414;
    DonorKind.Width := 145;
    DonorKind.Height := 22;
    DonorKind.ElementPosition := epIgnore;
    DonorKind.HeightStyle := ssAuto;
    DonorKind.HeightPercent := 100.000000000000000000;
    DonorKind.WidthStyle := ssAuto;
    DonorKind.WidthPercent := 100.000000000000000000;
    SetEvent(DonorKind, Self, 'OnChange', 'DonorKindChange');
    DonorKind.DataField := 'DonorKind';
    DonorKind.DataSource := DataSource;
    DateOfDeath.SetParentComponent(Self);
    DateOfDeath.Name := 'DateOfDeath';
    DateOfDeath.Left := 563;
    DateOfDeath.Top := 340;
    DateOfDeath.Width := 170;
    DateOfDeath.Height := 22;
    DateOfDeath.ElementClassName := 'form-control';
    DateOfDeath.HeightStyle := ssAuto;
    DateOfDeath.WidthStyle := ssAuto;
    DateOfDeath.BorderStyle := bsSingle;
    DateOfDeath.ChildOrder := 36;
    DateOfDeath.Color := clWhite;
    DateOfDeath.Date := 46139.473823032410000000;
    DateOfDeath.ElementPosition := epIgnore;
    DateOfDeath.Role := '';
    DateOfDeath.Text := '';
    SetEvent(DateOfDeath, Self, 'OnExit', 'DateOfDeathExit');
    DateOfDeath.DataField := 'DateOfDeath';
    DateOfDeath.DataSource := DataSource;
    edPostCode.SetParentComponent(Self);
    edPostCode.Name := 'edPostCode';
    edPostCode.Left := 253;
    edPostCode.Top := 197;
    edPostCode.Width := 200;
    edPostCode.Height := 22;
    edPostCode.AutoSelect := False;
    edPostCode.CharCase := wecUpperCase;
    edPostCode.ChildOrder := 37;
    edPostCode.ElementClassName := 'form-control';
    edPostCode.ElementPosition := epIgnore;
    edPostCode.HeightStyle := ssAuto;
    edPostCode.HeightPercent := 100.000000000000000000;
    edPostCode.TabOrder := 8;
    edPostCode.WidthStyle := ssAuto;
    edPostCode.WidthPercent := 100.000000000000000000;
    SetEvent(edPostCode, Self, 'OnChange', 'edPostCodeChange');
    SetEvent(edPostCode, Self, 'OnExit', 'edPostCodeExit');
    DonorDataset.SetParentComponent(Self);
    DonorDataset.Name := 'DonorDataset';
    DonorDataset.AfterApplyUpdates := DonorDatasetAfterApplyUpdates;
    DonorDataset.EntitySetName := 'Donor';
    DonorDataset.Connection := MainData.DataConnection;
    DonorDataset.Left := 48;
    DonorDataset.Top := 8;
    DonorDatasetId.SetParentComponent(DonorDataset);
    DonorDatasetId.Name := 'DonorDatasetId';
    DonorDatasetId.FieldName := 'Id';
    DonorDatasetDateAdded.SetParentComponent(DonorDataset);
    DonorDatasetDateAdded.Name := 'DonorDatasetDateAdded';
    DonorDatasetDateAdded.FieldName := 'DateAdded';
    DonorDatasetAddedBy.SetParentComponent(DonorDataset);
    DonorDatasetAddedBy.Name := 'DonorDatasetAddedBy';
    DonorDatasetAddedBy.FieldName := 'AddedBy';
    DonorDatasetLastUpdatedBy.SetParentComponent(DonorDataset);
    DonorDatasetLastUpdatedBy.Name := 'DonorDatasetLastUpdatedBy';
    DonorDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    DonorDatasetLastUpdated.SetParentComponent(DonorDataset);
    DonorDatasetLastUpdated.Name := 'DonorDatasetLastUpdated';
    DonorDatasetLastUpdated.FieldName := 'LastUpdated';
    DonorDatasetTitle.SetParentComponent(DonorDataset);
    DonorDatasetTitle.Name := 'DonorDatasetTitle';
    DonorDatasetTitle.FieldName := 'Title';
    DonorDatasetTitle.Size := 25;
    DonorDatasetFirstName.SetParentComponent(DonorDataset);
    DonorDatasetFirstName.Name := 'DonorDatasetFirstName';
    DonorDatasetFirstName.FieldName := 'FirstName';
    DonorDatasetFirstName.Size := 50;
    DonorDatasetMiddleName.SetParentComponent(DonorDataset);
    DonorDatasetMiddleName.Name := 'DonorDatasetMiddleName';
    DonorDatasetMiddleName.FieldName := 'MiddleName';
    DonorDatasetMiddleName.Size := 50;
    DonorDatasetLastName.SetParentComponent(DonorDataset);
    DonorDatasetLastName.Name := 'DonorDatasetLastName';
    DonorDatasetLastName.FieldName := 'LastName';
    DonorDatasetLastName.Size := 50;
    DonorDatasetSuffix.SetParentComponent(DonorDataset);
    DonorDatasetSuffix.Name := 'DonorDatasetSuffix';
    DonorDatasetSuffix.FieldName := 'Suffix';
    DonorDatasetSuffix.Size := 50;
    DonorDatasetAdd1.SetParentComponent(DonorDataset);
    DonorDatasetAdd1.Name := 'DonorDatasetAdd1';
    DonorDatasetAdd1.FieldName := 'Add1';
    DonorDatasetAdd1.Size := 75;
    DonorDatasetAdd2.SetParentComponent(DonorDataset);
    DonorDatasetAdd2.Name := 'DonorDatasetAdd2';
    DonorDatasetAdd2.FieldName := 'Add2';
    DonorDatasetAdd2.Size := 75;
    DonorDatasetAdd3.SetParentComponent(DonorDataset);
    DonorDatasetAdd3.Name := 'DonorDatasetAdd3';
    DonorDatasetAdd3.FieldName := 'Add3';
    DonorDatasetAdd3.Size := 75;
    DonorDatasetCity.SetParentComponent(DonorDataset);
    DonorDatasetCity.Name := 'DonorDatasetCity';
    DonorDatasetCity.FieldName := 'City';
    DonorDatasetCity.Size := 75;
    DonorDatasetPostCode.SetParentComponent(DonorDataset);
    DonorDatasetPostCode.Name := 'DonorDatasetPostCode';
    DonorDatasetPostCode.FieldName := 'PostCode';
    DonorDatasetPostCode.Size := 15;
    DonorDatasetEmail.SetParentComponent(DonorDataset);
    DonorDatasetEmail.Name := 'DonorDatasetEmail';
    DonorDatasetEmail.FieldName := 'Email';
    DonorDatasetEmail.Size := 75;
    DonorDatasetMobile.SetParentComponent(DonorDataset);
    DonorDatasetMobile.Name := 'DonorDatasetMobile';
    DonorDatasetMobile.FieldName := 'Mobile';
    DonorDatasetMobile.Size := 25;
    DonorDatasetTelephone.SetParentComponent(DonorDataset);
    DonorDatasetTelephone.Name := 'DonorDatasetTelephone';
    DonorDatasetTelephone.FieldName := 'Telephone';
    DonorDatasetTelephone.Size := 25;
    DonorDatasetMatchHash.SetParentComponent(DonorDataset);
    DonorDatasetMatchHash.Name := 'DonorDatasetMatchHash';
    DonorDatasetMatchHash.FieldName := 'MatchHash';
    DonorDatasetMatchHash.Size := 64;
    DonorDatasetVersion.SetParentComponent(DonorDataset);
    DonorDatasetVersion.Name := 'DonorDatasetVersion';
    DonorDatasetVersion.FieldName := 'Version';
    DonorDatasetContactByPhone.SetParentComponent(DonorDataset);
    DonorDatasetContactByPhone.Name := 'DonorDatasetContactByPhone';
    DonorDatasetContactByPhone.FieldName := 'ContactByPhone';
    DonorDatasetContactByPost.SetParentComponent(DonorDataset);
    DonorDatasetContactByPost.Name := 'DonorDatasetContactByPost';
    DonorDatasetContactByPost.FieldName := 'ContactByPost';
    DonorDatasetContactByText.SetParentComponent(DonorDataset);
    DonorDatasetContactByText.Name := 'DonorDatasetContactByText';
    DonorDatasetContactByText.FieldName := 'ContactByText';
    DonorDatasetContactByEmail.SetParentComponent(DonorDataset);
    DonorDatasetContactByEmail.Name := 'DonorDatasetContactByEmail';
    DonorDatasetContactByEmail.FieldName := 'ContactByEmail';
    DonorDatasetDOB.SetParentComponent(DonorDataset);
    DonorDatasetDOB.Name := 'DonorDatasetDOB';
    DonorDatasetDOB.FieldName := 'DOB';
    DonorDatasetHearingStatus.SetParentComponent(DonorDataset);
    DonorDatasetHearingStatus.Name := 'DonorDatasetHearingStatus';
    DonorDatasetHearingStatus.FieldName := 'HearingStatus';
    DonorDatasetHearingStatus.Size := 8;
    DonorDatasetEmailStatus.SetParentComponent(DonorDataset);
    DonorDatasetEmailStatus.Name := 'DonorDatasetEmailStatus';
    DonorDatasetEmailStatus.FieldName := 'EmailStatus';
    DonorDatasetEmailStatus.Size := 10;
    DonorDatasetLatitude.SetParentComponent(DonorDataset);
    DonorDatasetLatitude.Name := 'DonorDatasetLatitude';
    DonorDatasetLatitude.FieldName := 'Latitude';
    DonorDatasetLongitude.SetParentComponent(DonorDataset);
    DonorDatasetLongitude.Name := 'DonorDatasetLongitude';
    DonorDatasetLongitude.FieldName := 'Longitude';
    DonorDatasetExternalId.SetParentComponent(DonorDataset);
    DonorDatasetExternalId.Name := 'DonorDatasetExternalId';
    DonorDatasetExternalId.FieldName := 'ExternalId';
    DonorDatasetExternalId.Size := 64;
    DonorDatasetCountryCode.SetParentComponent(DonorDataset);
    DonorDatasetCountryCode.Name := 'DonorDatasetCountryCode';
    DonorDatasetCountryCode.FieldName := 'CountryCode';
    DonorDatasetCountryCode.Size := 3;
    DonorDatasetVisualStatus.SetParentComponent(DonorDataset);
    DonorDatasetVisualStatus.Name := 'DonorDatasetVisualStatus';
    DonorDatasetVisualStatus.FieldName := 'VisualStatus';
    DonorDatasetVisualStatus.Size := 8;
    DonorDatasetMobilityStatus.SetParentComponent(DonorDataset);
    DonorDatasetMobilityStatus.Name := 'DonorDatasetMobilityStatus';
    DonorDatasetMobilityStatus.FieldName := 'MobilityStatus';
    DonorDatasetMobilityStatus.Size := 8;
    DonorDatasetSourceType.SetParentComponent(DonorDataset);
    DonorDatasetSourceType.Name := 'DonorDatasetSourceType';
    DonorDatasetSourceType.FieldName := 'SourceType';
    DonorDatasetSourceType.Size := 9;
    DonorDatasetClaimStatus.SetParentComponent(DonorDataset);
    DonorDatasetClaimStatus.Name := 'DonorDatasetClaimStatus';
    DonorDatasetClaimStatus.FieldName := 'ClaimStatus';
    DonorDatasetClaimStatus.Size := 19;
    DonorDatasetCharityTenant.SetParentComponent(DonorDataset);
    DonorDatasetCharityTenant.Name := 'DonorDatasetCharityTenant';
    DonorDatasetCharityTenant.FieldName := 'CharityTenant';
    DonorDatasetComments.SetParentComponent(DonorDataset);
    DonorDatasetComments.Name := 'DonorDatasetComments';
    DonorDatasetComments.FieldName := 'Comments';
    DonorDatasetComments.Size := 255;
    DonorDatasetImportId.SetParentComponent(DonorDataset);
    DonorDatasetImportId.Name := 'DonorDatasetImportId';
    DonorDatasetImportId.FieldName := 'ImportId';
    DonorDatasetCounty.SetParentComponent(DonorDataset);
    DonorDatasetCounty.Name := 'DonorDatasetCounty';
    DonorDatasetCounty.FieldName := 'County';
    DonorDatasetCounty.Size := 75;
    DonorDatasetLocationType.SetParentComponent(DonorDataset);
    DonorDatasetLocationType.Name := 'DonorDatasetLocationType';
    DonorDatasetLocationType.FieldName := 'LocationType';
    DonorDatasetLocationType.Size := 8;
    DonorDatasetOrganisationName.SetParentComponent(DonorDataset);
    DonorDatasetOrganisationName.Name := 'DonorDatasetOrganisationName';
    DonorDatasetOrganisationName.FieldName := 'OrganisationName';
    DonorDatasetOrganisationName.Size := 250;
    DonorDatasetDonorKind.SetParentComponent(DonorDataset);
    DonorDatasetDonorKind.Name := 'DonorDatasetDonorKind';
    DonorDatasetDonorKind.FieldName := 'DonorKind';
    DonorDatasetDonorKind.Size := 10;
    DonorDatasetDateOfDeath.SetParentComponent(DonorDataset);
    DonorDatasetDateOfDeath.Name := 'DonorDatasetDateOfDeath';
    DonorDatasetDateOfDeath.FieldName := 'DateOfDeath';
    DonorDatasetDateOfDeath.DisplayFormat := 'DD/MM/YYYY';
    DataSource.DataSet := DonorDataset;
    DataSource.Left := 160;
    DataSource.Top := 16;
    CloseTimer.Left := 504;
    CloseTimer.Top := 40;
  finally
    DonorIdLabel.AfterLoadDFMValues;
    ExternalIdLabel.AfterLoadDFMValues;
    CancelButton.AfterLoadDFMValues;
    SaveButton.AfterLoadDFMValues;
    edFirstName.AfterLoadDFMValues;
    edLastName.AfterLoadDFMValues;
    edAdd1.AfterLoadDFMValues;
    edAdd2.AfterLoadDFMValues;
    edAdd3.AfterLoadDFMValues;
    edCity.AfterLoadDFMValues;
    edEmail.AfterLoadDFMValues;
    edMobile.AfterLoadDFMValues;
    edTelephone.AfterLoadDFMValues;
    ClaimStatus.AfterLoadDFMValues;
    Comments.AfterLoadDFMValues;
    ContactByPhone.AfterLoadDFMValues;
    ContactByEmail.AfterLoadDFMValues;
    ContactByText.AfterLoadDFMValues;
    ContactByPost.AfterLoadDFMValues;
    DataState.AfterLoadDFMValues;
    TitleEdit.AfterLoadDFMValues;
    ExternalIdEdit.AfterLoadDFMValues;
    edCounty.AfterLoadDFMValues;
    CountryList.AfterLoadDFMValues;
    DefaultsButton.AfterLoadDFMValues;
    DeclarationsButton.AfterLoadDFMValues;
    DonorCommentMemo.AfterLoadDFMValues;
    OrganisationName.AfterLoadDFMValues;
    DonorKind.AfterLoadDFMValues;
    DateOfDeath.AfterLoadDFMValues;
    edPostCode.AfterLoadDFMValues;
    DonorDataset.AfterLoadDFMValues;
    DonorDatasetId.AfterLoadDFMValues;
    DonorDatasetDateAdded.AfterLoadDFMValues;
    DonorDatasetAddedBy.AfterLoadDFMValues;
    DonorDatasetLastUpdatedBy.AfterLoadDFMValues;
    DonorDatasetLastUpdated.AfterLoadDFMValues;
    DonorDatasetTitle.AfterLoadDFMValues;
    DonorDatasetFirstName.AfterLoadDFMValues;
    DonorDatasetMiddleName.AfterLoadDFMValues;
    DonorDatasetLastName.AfterLoadDFMValues;
    DonorDatasetSuffix.AfterLoadDFMValues;
    DonorDatasetAdd1.AfterLoadDFMValues;
    DonorDatasetAdd2.AfterLoadDFMValues;
    DonorDatasetAdd3.AfterLoadDFMValues;
    DonorDatasetCity.AfterLoadDFMValues;
    DonorDatasetPostCode.AfterLoadDFMValues;
    DonorDatasetEmail.AfterLoadDFMValues;
    DonorDatasetMobile.AfterLoadDFMValues;
    DonorDatasetTelephone.AfterLoadDFMValues;
    DonorDatasetMatchHash.AfterLoadDFMValues;
    DonorDatasetVersion.AfterLoadDFMValues;
    DonorDatasetContactByPhone.AfterLoadDFMValues;
    DonorDatasetContactByPost.AfterLoadDFMValues;
    DonorDatasetContactByText.AfterLoadDFMValues;
    DonorDatasetContactByEmail.AfterLoadDFMValues;
    DonorDatasetDOB.AfterLoadDFMValues;
    DonorDatasetHearingStatus.AfterLoadDFMValues;
    DonorDatasetEmailStatus.AfterLoadDFMValues;
    DonorDatasetLatitude.AfterLoadDFMValues;
    DonorDatasetLongitude.AfterLoadDFMValues;
    DonorDatasetExternalId.AfterLoadDFMValues;
    DonorDatasetCountryCode.AfterLoadDFMValues;
    DonorDatasetVisualStatus.AfterLoadDFMValues;
    DonorDatasetMobilityStatus.AfterLoadDFMValues;
    DonorDatasetSourceType.AfterLoadDFMValues;
    DonorDatasetClaimStatus.AfterLoadDFMValues;
    DonorDatasetCharityTenant.AfterLoadDFMValues;
    DonorDatasetComments.AfterLoadDFMValues;
    DonorDatasetImportId.AfterLoadDFMValues;
    DonorDatasetCounty.AfterLoadDFMValues;
    DonorDatasetLocationType.AfterLoadDFMValues;
    DonorDatasetOrganisationName.AfterLoadDFMValues;
    DonorDatasetDonorKind.AfterLoadDFMValues;
    DonorDatasetDateOfDeath.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    CloseTimer.AfterLoadDFMValues;
  end;
end;

end.



